import { action
       , computed
       , observable }             from 'mobx' ;

import { ERROR_CODE
       , ERROR_MSG
       , tr_error }               from '../00_assets' ;
import { API }                    from '../02_api' ;



let g_login_m: MLogin ;


export class MLogin
{
  @observable cloud: string = '' ;
  @observable user: string = '' ;
  @observable pass: string = '' ;
  @observable error: string = '' ;
  

  static instance ( )
  {
    if ( !g_login_m )
         g_login_m = new MLogin( ) ;

    return g_login_m ;
  }


  on_login = async ( ev: React.FormEvent<HTMLFormElement> ) =>
  {
    ev.preventDefault( ) ;

    const response = await API.AUTH.add!( { username: this.user,  cloudname: this.cloud, password: this.pass } ) ;

    if ( response.error.code === ERROR_CODE.NONE )
      {
        this.cloud = '' ;
        this.user = '' ;
        this.pass = '' ;
      }
    else
        this.set_error( tr_error( response.error, ERROR_MSG.LOGIN ) ) ;
  }
  
  @action set_error ( msg: string )
  {
     this.error = msg ;
  }

  @action on_user_change = ( ev: React.ChangeEvent<HTMLInputElement> ) =>
  {
    this.error = '' ;
    this.user = ev.target.value ;
  }

  @action on_cloud_change = ( ev: React.ChangeEvent<HTMLInputElement> ) =>
  {
    this.error = '' ;
    this.cloud = ev.target.value ;
  }

  @action on_pass_change = ( ev: React.ChangeEvent<HTMLInputElement> ) =>
  {
    this.error = '' ;
    this.pass = ev.target.value ;
  }

  @computed get login_button_disable ( )
  {
    return this.user.length < 3 || this.cloud.length < 3 || this.pass.length < 3 ;
  }
}